<template>
  <tr class="preset-copy-row text-center">
    <td class="text-left pl-6 pl-md-4">
      <div class="d-flex flex-row align-center">
        {{ vacancy.title }}
      </div>
    </td>
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <td class="candidates-td">
        <template v-if="isActive">
          <div>
            {{ vacancy.counts.candidates }}
          </div>
        </template>
        <div
          v-if="!isActive"
          class="height-holder"
        />
      </td>
      <td>
        <template v-if="isActive">
          <div>
            {{ vacancy.counts.interviews }}
            <span
              v-if="vacancy.counts.interviewsNew"
              class="red--text"
            >
              (+{{ vacancy.counts.interviewsNew }})
            </span>
          </div>
        </template>
      </td>
      <td>
        {{ vacancy.counts.questions }}
      </td>
    </template>
    <td>
      <div class="d-flex">
        <VBtn
          class="ml-auto"
          color="success"
          :loading="loader"
          :outlined="!$vuetify.breakpoint.mdAndUp"
          @click="select"
        >
          {{ $t('select') }}
        </VBtn>
      </div>
    </td>
  </tr>
</template>

<script>

import { vacancyStatus, wizardSteps } from '@/enums';
import ValidationMixin from '@/mixins/ValidationMixin';
import Wizard from '@/orm/models/Wizard/Wizard';
import Vacancy from '@/orm/models/Vacancy/Vacancy';

export default {
  name: 'VacancyPresetCopyTableRow',
  mixins: [ValidationMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
    };
  },
  computed: {
    externalUrl() {
      return `${process.env.VUE_APP_FRONT_URL}/v/${this.vacancy.id}`;
    },
    isActive() {
      return this.vacancy.status === vacancyStatus.ACTIVE;
    },
  },
  methods: {
    async select() {
      this.withApiErrorHandling(async () => {
        await Vacancy.api().cloneScript(this.$route.params.vacancyId, this.vacancy.id);
        const vacancy = Vacancy.query().withAllRecursive().find(this.$route.params.vacancyId);
        await this.submit(vacancy.script.questions, vacancy.script.interviewerId);
        this.$router.push({
          name: 'vacancy-questions',
          params: {
            vacancyId: this.$route.params.vacancyId,
            interviewerId: vacancy.script.interviewerId,
            presetId: '1',
          },
        });
      }, (error) => {
        this.$toast.error(error.message);
      }, 'loader');
    },
    async submit(questions, interviewerId) {
      Wizard.setSelectedQuestions(questions);
      Wizard.setInterviewerId(interviewerId);
      Wizard.setPrevStep(wizardSteps.PRESET);
      await Wizard.saveWizardState();
    },
  },
};
</script>

<style lang="scss" scoped>
  .preset-copy-row td {
    vertical-align: middle !important;
    text-align: left !important;
  }

  .vacancy-name-link {
    font-size: 14px;
    text-decoration: none;
    word-break: break-word;
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .vacancy-name-link {
      font-size: 1.125rem !important;
      text-decoration: underline;
    }

    .candidates-td {
      .height-holder {
        min-height: 48px;
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
  select: Select
</i18n>

<i18n locale="ru" lang="yaml">
    select: Выбрать
</i18n>
